import { render, staticRenderFns } from "./inherit.vue?vue&type=template&id=c91cd34c&"
import script from "./inherit.vue?vue&type=script&lang=js&"
export * from "./inherit.vue?vue&type=script&lang=js&"
import style0 from "./inherit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports